import _ from 'lodash';
import {matchParticipantCategories} from './matchParticipantCategories';

export function filterParticipantsByCategories(participants, filterParams) {
    let filtered = participants;

    if (filterParams.categories) {
        for (let cat in filterParams.categories) {
            const options = filterParams.categories[cat];
            filtered = filtered.filter(participant => matchParticipantCategories(cat, options, participant.categories));
        }
    }

    return filtered;
}
